import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function MesafeliSatisSozlesmesiPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              Mesafeli Satış Sözleşmesi
            </h1>

            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 1 - Taraflar</h2>
                <div className="bg-gold-50 p-6 rounded-lg space-y-2">
                  <p><strong>SATICI:</strong></p>
                  <p>Unvan: Emin Kuyumculuk</p>
                  <p>Adres: Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                  <p>Telefon: 0531 603 68 91</p>
                  <p>E-posta: info@eminkuyumculuk.com.tr</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 2 - Konu</h2>
                <p>
                  Bu sözleşmenin konusu, ALICI'nın SATICI'ya ait www.eminkuyumculuk.com.tr internet sitesi üzerinden 
                  elektronik ortamda siparişini verdiği altın ve kuyumculuk ürünlerinin satışı ve teslimi ile ilgili 
                  olarak tarafların hak ve yükümlülüklerinin belirlenmesidir.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 3 - Ürün Bilgileri</h2>
                <p>
                  SATICI tarafından satışa sunulan ürünlerin temel nitelikleri (tür, miktar, marka/model, renk, 
                  adet, gramaj vs.) satış sitesinde yer almaktadır. ALICI, sözleşme konusu ürünün temel niteliklerini 
                  inceleme ve bilgi edinme imkanına sahip olmuş ve elektronik ortamda onay vermiştir.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 4 - Fiyat ve Ödeme</h2>
                <div className="space-y-3">
                  <p>
                    Sözleşme konusu ürün/ürünlerin KDV dahil satış fiyatı, ödeme şekli ve temel nitelikleri 
                    aşağıda belirtilmiştir:
                  </p>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p><strong>Ödeme Yöntemleri:</strong></p>
                    <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                      <li>Kredi Kartı (Tek Çekim ve Taksit)</li>
                      <li>Banka Havalesi/EFT</li>
                      <li>Kapıda Ödeme (Nakit/Kredi Kartı)</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 5 - Teslimat</h2>
                <div className="space-y-3">
                  <p>
                    <strong>Teslimat Süresi:</strong> Ürünler, siparişin onaylanmasından sonra en geç 3 iş günü 
                    içerisinde kargoya verilir.
                  </p>
                  <p>
                    <strong>Teslimat Şekli:</strong> Anlaşmalı kargo firmaları aracılığıyla, ALICI'nın belirttiği 
                    adrese teslim edilir.
                  </p>
                  <p>
                    <strong>Kargo Ücreti:</strong> 500 TL ve üzeri alışverişlerde ücretsizdir. 
                    500 TL altı alışverişlerde kargo bedeli ALICI'ya aittir.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 6 - Cayma Hakkı</h2>
                <div className="space-y-3">
                  <p>
                    ALICI, ürünü teslim aldığı tarihten itibaren 14 gün içinde herhangi bir gerekçe göstermeksizin 
                    ve cezai şart ödemeksizin sözleşmeden cayabilir.
                  </p>
                  <p><strong>Cayma hakkı kullanılamayan durumlar:</strong></p>
                  <ul className="list-disc list-inside ml-4 space-y-1">
                    <li>Müşterinin isteği üzerine özel olarak hazırlanan ürünler</li>
                    <li>Hijyen ve sağlık açısından uygun olmayan ürünler</li>
                    <li>Teslim sonrası ambalajı açılmış olan ürünler</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 7 - Garanti ve Servis</h2>
                <p>
                  Satılan tüm ürünler için yasal garanti koşulları geçerlidir. Ürünlerde herhangi bir 
                  kalite sorunu tespit edilmesi halinde ALICI, Tüketici Hakları mevzuatı uyarınca 
                  haklarını kullanabilir.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 8 - Yürürlük</h2>
                <p>
                  Bu sözleşme, ALICI tarafından elektronik ortamda onaylandığı anda yürürlüğe girer. 
                  SATICI, siparişi kabul etmediği takdirde ALICI'yı bilgilendirir ve sözleşme 
                  kendiliğinden sona erer.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Madde 9 - Uyuşmazlıklar</h2>
                <p>
                  Bu sözleşmeden doğabilecek uyuşmazlıklarda SATICI'nın bulunduğu yerdeki 
                  Tüketici Sorunları Hakem Heyeti ve Tüketici Mahkemeleri yetkilidir.
                </p>
              </section>

              <div className="bg-gold-50 p-6 rounded-lg mt-8">
                <h3 className="font-semibold text-gray-800 mb-2">İletişim</h3>
                <p>Sözleşme ile ilgili sorularınız için:</p>
                <p><strong>Telefon:</strong> 0531 603 68 91</p>
                <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}